import walidacjaOpisu from '@components/form/validation/field/opis'
import validated from '@components/form/validation/validated'

export default validated({
    t: 'Opis',
    name: 'opis',

}, walidacjaOpisu)